import { Fragment } from "react";
import BoxTitle from "../../../TEMPLATE/components/box/title/BoxTitle";
import { diavLink } from "../../hardCodeData/DATA";
import { Link } from "react-router-dom";

const CustomCategoryDiav = () => {
  return (
    <Fragment>
      <BoxTitle
        icon={"im im-icon-Speach-BubbleDialog"}
        title={"ΔΗΜΟΣΙΕΣ ΔΙΑΒΟΥΛΕΥΣΕΙΣ"}
        externalLink={diavLink}
        infoContext={
          "Παρακολουθήστε και συμμετέχετε ενεργά στη δημόσια διαβούλευση για τη διαδικασία λήψης αποφάσεων κατά τον σχεδιασμό και την εφαρμογή έργων και πολιτικών στο Δήμο μας"
        }
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <p
        style={{
          marginTop: 10,
          color: "white",
          padding: 10,
          textAlign: "justify",
          lineHeight: "1.5",
          marginBottom: "20px",
        }}
      >
        Ισότιμη συμμετοχή σε έναν ευρύτερο δημόσιο διάλογο
      </p>
      <Link
        style={{
          marginLeft: "calc((100% - 141.48px ) /2)",
          borderRadius: "30px",
          border: "none",
          cursor: "pointer",
          color: "#000",
          backgroundColor: "white",
          padding: "20px 40px",
        }}
        // to={"/diavouleuseis"}
        onClick={() => window.open(diavLink, "_blank")}
      >
        <span
          style={{
            fontWeight: "700",
            fontSize: "16px",
          }}
        >
          Είσοδος
        </span>
      </Link>
    </Fragment>
  );
};
export default CustomCategoryDiav;
